import { __decorate } from "tslib";
// import { objAny } from "@/common/common-interface";
import { Component, Vue, Prop } from "vue-property-decorator";
import { findComponentUpward } from "@/common/assist";
let PiRadio = class PiRadio extends Vue {
    constructor() {
        super(...arguments);
        this.parent = findComponentUpward(this, "PiRadioGroup"); // 找出父级
        this.radio = "";
        this.groupName = "";
        this.group = false;
        this.itemDisabled = false;
    }
    change() {
        if (!this.disabled) {
            if (this.group) {
                if (this.label !== undefined) {
                    this.parent.change(this.label);
                }
            }
            else {
                this.$emit("on-change", this.label);
            }
        }
    }
    mounted() {
        if (this.parent) {
            this.group = true;
            this.groupName = this.parent.name;
            this.parent.childLoadingSuccess();
        }
    }
};
__decorate([
    Prop({ default: false })
], PiRadio.prototype, "disabled", void 0);
__decorate([
    Prop({ default: "" })
], PiRadio.prototype, "label", void 0);
__decorate([
    Prop({ default: "" })
], PiRadio.prototype, "name", void 0);
PiRadio = __decorate([
    Component
], PiRadio);
export default PiRadio;
